//@flow
// imports that just need to be in the bundle somewhere
import '@babel/polyfill';

import render from '../public/js/Utils/client-app';
import officeRouter from '../public/js/ReactRouters/officeRouter';

render(officeRouter);
